import { Container } from '@ag1/ui';
import { memo } from 'react';
import FooterContentLander from './FooterContentLander/FooterContentLander';
import FooterContentMain from './FooterContentMain/FooterContentMain';
import { FooterContext } from './FooterContext';
import styles from './styles.module.scss';
import { FooterProps } from './types';

const Footer = (props: FooterProps) => {
  const {
    data: { isForLanderPage }
  } = props;

  return (
    <FooterContext.Provider value={props}>
      <footer className={styles.root}>
        <Container narrow={isForLanderPage}>
          {isForLanderPage ? <FooterContentLander /> : <FooterContentMain />}
        </Container>
      </footer>
    </FooterContext.Provider>
  );
};

export default memo(Footer);
